import script from "./contedo-settings.vue?vue&type=script&setup=true&lang=js"
export * from "./contedo-settings.vue?vue&type=script&setup=true&lang=js"

import "./contedo-settings.vue?vue&type=style&index=0&id=3379929c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3379929c"]])

export default __exports__